const minutesToHours = (minutes: number): string => {
    if (!minutes || minutes < 0) {
        return '0:00';
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}:${remainingMinutes}${remainingMinutes < 10 ? '0' : ''}`;
};

export default minutesToHours;
